import { render, staticRenderFns } from "./ClientBasicInfo.vue?vue&type=template&id=a472e784&scoped=true&"
import script from "./ClientBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ClientBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientBasicInfo.vue?vue&type=style&index=0&id=a472e784&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472e784",
  null
  
)

export default component.exports